function PairsWithInit({ sectionId, productId, addToCartLabel }) {
  const dataEl = document.getElementById(`pairs-with-data-${sectionId}`);
  if (!dataEl) return;

  let recipes = [];
  try {
    recipes = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Pairs With: failed to parse recipe data', e);
    return;
  }

  if (!recipes.length) return;

  const trigger     = document.getElementById(`pairs-with-trigger-${sectionId}`);
  const panel       = document.getElementById(`pairs-with-panel-${sectionId}`);
  const grid        = document.getElementById(`pairs-with-grid-${sectionId}`);
  const iconsWrap   = document.getElementById(`pairs-with-icons-${sectionId}`);
  const recipeWrap  = document.getElementById(`pairs-with-recipe-${sectionId}`);
  const recipeInner = document.getElementById(`pairs-with-recipe-inner-${sectionId}`);
  const backBtn     = document.getElementById(`pairs-with-back-${sectionId}`);

  const ICON_MAP = {
    chicken:    'ti-drumstick',
    fish:       'ti-fish',
    beef:       'ti-meat',
    eggs:       'ti-egg',
    oysters:    'ti-fish',
    tacos:      'ti-taco',
    pizza:      'ti-pizza',
    sandwiches: 'ti-sandwich'
  };

  recipes.forEach((recipe, index) => {
    const category = (recipe.food_category || '').toLowerCase();
    const iconClass = ICON_MAP[category] || 'ti-tools-kitchen-2';
    const label = recipe.food_label || recipe.food_category || '';

    const btn = document.createElement('button');
    btn.className = 'pairs-with__food-btn';
    btn.setAttribute('aria-label', label);
    btn.dataset.index = index;
    btn.innerHTML = `
      <span class="pairs-with__food-icon-wrap">
        <i class="ti ${iconClass}"></i>
      </span>
      <span class="pairs-with__food-label">${label}</span>
    `;
    btn.addEventListener('click', () => showRecipe(index));
    iconsWrap.appendChild(btn);
  });

  trigger.addEventListener('click', () => {
    const isOpen = !panel.hidden;
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
    trigger.classList.toggle('is-open', !isOpen);
  });

  backBtn.addEventListener('click', () => {
    recipeWrap.hidden = true;
    grid.hidden = false;
  });

  function showRecipe(index) {
    const r = recipes[index];
    if (!r) return;

    grid.hidden = true;
    recipeWrap.hidden = false;

    const ingredients = Array.isArray(r.ingredients) ? r.ingredients : [];
    const steps = Array.isArray(r.steps) ? r.steps : [];

    const chefPhoto = r.chef && r.chef.photo
      ? `<img src="${r.chef.photo}" alt="${r.chef.name || ''}" class="pairs-with__chef-photo">`
      : `<div class="pairs-with__chef-initials">${r.chef && r.chef.initials ? r.chef.initials : '?'}</div>`;

    const chefInstagram = r.chef && r.chef.instagram_url
      ? `<a href="${r.chef.instagram_url}" target="_blank" rel="noopener" class="pairs-with__chef-ig"><i class="ti ti-brand-instagram"></i></a>`
      : '';

    const ingredientsHTML = ingredients.map(ing => `
      <li class="pairs-with__ingredient${ing.highlight ? ' is-highlighted' : ''}">
        <span class="pairs-with__ingredient-name">${ing.name || ''}</span>
        <span class="pairs-with__ingredient-amount">${ing.amount || ''}</span>
      </li>
    `).join('');

    const stepsHTML = steps.map((step, i) => `
      <li class="pairs-with__step">
        <span class="pairs-with__step-num">${i + 1}</span>
        <span class="pairs-with__step-text">${step}</span>
      </li>
    `).join('');

    const tagHTML = r.tag ? `<span class="pairs-with__tag">${r.tag}</span>` : '';
    const metaHTML = [
      r.cook_time  ? `<span><i class="ti ti-clock"></i> ${r.cook_time}</span>`  : '',
      r.servings   ? `<span><i class="ti ti-users"></i> ${r.servings}</span>`   : '',
      r.difficulty ? `<span><i class="ti ti-flame"></i> ${r.difficulty}</span>` : ''
    ].filter(Boolean).join('');

    recipeInner.innerHTML = `
      <div class="pairs-with__card">
        ${tagHTML}
        <h2 class="pairs-with__recipe-title">${r.title || ''}</h2>
        <div class="pairs-with__meta">${metaHTML}</div>
        <div class="pairs-with__chef">
          ${chefPhoto}
          <div class="pairs-with__chef-info">
            <span class="pairs-with__chef-name">${r.chef && r.chef.name ? r.chef.name : ''}</span>
            <span class="pairs-with__chef-title">${r.chef && r.chef.title ? r.chef.title : ''}</span>
          </div>
          ${chefInstagram}
        </div>
        <div class="pairs-with__section-label">Ingredients</div>
        <ul class="pairs-with__ingredients">${ingredientsHTML}</ul>
        <div class="pairs-with__section-label">Steps</div>
        <ol class="pairs-with__steps">${stepsHTML}</ol>
        ${r.finish_note ? `<div class="pairs-with__finish-note"><i class="ti ti-quote"></i> ${r.finish_note}</div>` : ''}
        <button class="pairs-with__atc" data-variant-id="${productId}">
          <i class="ti ti-shopping-cart"></i> ${addToCartLabel}
        </button>
      </div>
    `;

    recipeInner.querySelector('.pairs-with__atc').addEventListener('click', function () {
      const btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        btn.textContent = 'Added!';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = `<i class="ti ti-shopping-cart"></i> ${addToCartLabel}`;
          btn.classList.remove('is-added');
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
    });
  }
}
function PairsWithInit({ sectionId, productId, addToCartLabel }) {
  const dataEl = document.getElementById(`pairs-with-data-${sectionId}`);
  if (!dataEl) return;

  let recipes = [];
  try {
    recipes = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Pairs With: failed to parse recipe data', e);
    return;
  }

  if (!recipes.length) return;

  const trigger     = document.getElementById(`pairs-with-trigger-${sectionId}`);
  const panel       = document.getElementById(`pairs-with-panel-${sectionId}`);
  const grid        = document.getElementById(`pairs-with-grid-${sectionId}`);
  const iconsWrap   = document.getElementById(`pairs-with-icons-${sectionId}`);
  const recipeWrap  = document.getElementById(`pairs-with-recipe-${sectionId}`);
  const recipeInner = document.getElementById(`pairs-with-recipe-inner-${sectionId}`);
  const backBtn     = document.getElementById(`pairs-with-back-${sectionId}`);

  const ICON_MAP = {
    chicken:    'ti-drumstick',
    fish:       'ti-fish',
    beef:       'ti-meat',
    eggs:       'ti-egg',
    oysters:    'ti-fish',
    tacos:      'ti-taco',
    pizza:      'ti-pizza',
    sandwiches: 'ti-sandwich'
  };

  recipes.forEach((recipe, index) => {
    const category = (recipe.food_category || '').toLowerCase();
    const iconClass = ICON_MAP[category] || 'ti-tools-kitchen-2';
    const label = recipe.food_label || recipe.food_category || '';

    const btn = document.createElement('button');
    btn.className = 'pairs-with__food-btn';
    btn.setAttribute('aria-label', label);
    btn.dataset.index = index;
    btn.innerHTML = `
      <span class="pairs-with__food-icon-wrap">
        <i class="ti ${iconClass}"></i>
      </span>
      <span class="pairs-with__food-label">${label}</span>
    `;
    btn.addEventListener('click', () => showRecipe(index));
    iconsWrap.appendChild(btn);
  });

  trigger.addEventListener('click', () => {
    const isOpen = !panel.hidden;
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
    trigger.classList.toggle('is-open', !isOpen);
  });

  backBtn.addEventListener('click', () => {
    recipeWrap.hidden = true;
    grid.hidden = false;
  });

  function showRecipe(index) {
    const r = recipes[index];
    if (!r) return;

    grid.hidden = true;
    recipeWrap.hidden = false;

    const ingredients = Array.isArray(r.ingredients) ? r.ingredients : [];
    const steps = Array.isArray(r.steps) ? r.steps : [];

    const chefPhoto = r.chef && r.chef.photo
      ? `<img src="${r.chef.photo}" alt="${r.chef.name || ''}" class="pairs-with__chef-photo">`
      : `<div class="pairs-with__chef-initials">${r.chef && r.chef.initials ? r.chef.initials : '?'}</div>`;

    const chefInstagram = r.chef && r.chef.instagram_url
      ? `<a href="${r.chef.instagram_url}" target="_blank" rel="noopener" class="pairs-with__chef-ig"><i class="ti ti-brand-instagram"></i></a>`
      : '';

    const ingredientsHTML = ingredients.map(ing => `
      <li class="pairs-with__ingredient${ing.highlight ? ' is-highlighted' : ''}">
        <span class="pairs-with__ingredient-name">${ing.name || ''}</span>
        <span class="pairs-with__ingredient-amount">${ing.amount || ''}</span>
      </li>
    `).join('');

    const stepsHTML = steps.map((step, i) => `
      <li class="pairs-with__step">
        <span class="pairs-with__step-num">${i + 1}</span>
        <span class="pairs-with__step-text">${step}</span>
      </li>
    `).join('');

    const tagHTML = r.tag ? `<span class="pairs-with__tag">${r.tag}</span>` : '';
    const metaHTML = [
      r.cook_time  ? `<span><i class="ti ti-clock"></i> ${r.cook_time}</span>`  : '',
      r.servings   ? `<span><i class="ti ti-users"></i> ${r.servings}</span>`   : '',
      r.difficulty ? `<span><i class="ti ti-flame"></i> ${r.difficulty}</span>` : ''
    ].filter(Boolean).join('');

    recipeInner.innerHTML = `
      <div class="pairs-with__card">
        ${tagHTML}
        <h2 class="pairs-with__recipe-title">${r.title || ''}</h2>
        <div class="pairs-with__meta">${metaHTML}</div>
        <div class="pairs-with__chef">
          ${chefPhoto}
          <div class="pairs-with__chef-info">
            <span class="pairs-with__chef-name">${r.chef && r.chef.name ? r.chef.name : ''}</span>
            <span class="pairs-with__chef-title">${r.chef && r.chef.title ? r.chef.title : ''}</span>
          </div>
          ${chefInstagram}
        </div>
        <div class="pairs-with__section-label">Ingredients</div>
        <ul class="pairs-with__ingredients">${ingredientsHTML}</ul>
        <div class="pairs-with__section-label">Steps</div>
        <ol class="pairs-with__steps">${stepsHTML}</ol>
        ${r.finish_note ? `<div class="pairs-with__finish-note"><i class="ti ti-quote"></i> ${r.finish_note}</div>` : ''}
        <button class="pairs-with__atc" data-variant-id="${productId}">
          <i class="ti ti-shopping-cart"></i> ${addToCartLabel}
        </button>
      </div>
    `;

    recipeInner.querySelector('.pairs-with__atc').addEventListener('click', function () {
      const btn = this;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        btn.textContent = 'Added!';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = `<i class="ti ti-shopping-cart"></i> ${addToCartLabel}`;
          btn.classList.remove('is-added');
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
    });
  }
}
